import initialState from 'store/globalState/initialState';
import * as STATUS from 'constants/status';
import {
  FETCH_PROFILE_INIT,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  DELETE_ACCOUNT_INIT,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
} from './types';


const INITIAL_STATE = {
  error: '',
  success: '',
  eraseAccountStatus: null,
  eraseAccountError: null,
};

export default function profileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_PROFILE_INIT:
      return {
        error: '',
        success: '',
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        error: '',
        success: 'Success',
      };
    case FETCH_PROFILE_FAILURE:
      return {
        error: action.payload,
        success: '',
      };
    case DELETE_ACCOUNT_INIT:
      return {
        ...state,
        eraseAccountStatus: STATUS.STATUS_INIT,
        eraseAccountError: null,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        eraseAccountStatus: STATUS.STATUS_SUCCESS,
      };
    case DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        eraseAccountStatus: STATUS.STATUS_FAILURE,
        eraseAccountError: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Profile/modules/index.js